import React, { useState, useEffect, useRef } from 'react';
import '../components/styles/quickIntro.css'; 

const greetings = ['hey','Salam','Bonjour', 'Hola', 'Namaste', 'Ciao'];

function QuickIntro() {
    const [greetingIndex, setGreetingIndex] = useState(0);
    const [isAnimating, setIsAnimating] = useState(true);
    const [tilt, setTilt] = useState({ x: 0, y: 0 });
    const introRef = useRef(null);

    useEffect(() => {
        const interval = setInterval(() => {
            setIsAnimating(false);
            setTimeout(() => {
                setGreetingIndex((prevIndex) => (prevIndex + 1) % greetings.length);
                setIsAnimating(true);
            }, 600);
        }, 3000);

        return () => clearInterval(interval);
    }, []);

    const handleMouseMove = (e) => {
        if (!introRef.current) return;
        
        const rect = introRef.current.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        
        const centerX = rect.width / 2;
        const centerY = rect.height / 2;
        
        const tiltX = ((y - centerY) / centerY) * -10;
        const tiltY = ((x - centerX) / centerX) * 10;
        
        setTilt({ x: tiltX, y: tiltY });
    };

    const handleMouseLeave = () => {
        setTilt({ x: 0, y: 0 });
    };

    return (
        <>
        <div className='quick-intro-container' style={{ marginTop: "50px" }}>
            {/* <div className='self-image'>
                <img src={require('../assets/abdurimage2.jpeg')} alt='self-Intro' className='image' />
            </div> */}
            <div 
                className='intro-text' 
                ref={introRef}
                onMouseMove={handleMouseMove}
                onMouseLeave={handleMouseLeave}
                style={{
                    transform: `perspective(1000px) rotateX(${tilt.x}deg) rotateY(${tilt.y}deg)`,
                    transition: 'transform 0.1s ease-out'
                }}
            >
                <p className='bio'> <span className='quick-intro-name'><span className={`greeting-word ${isAnimating ? 'animate-in' : 'animate-out'}`}>{greetings[greetingIndex]}</span>, I'm Abdur Rahman.</span> I'm a Entrepreneur and software engineer. </p>
                <div className='social-links'>
                    <a href='https://github.com/A-Rahman-19' target='_blank' rel='noopener noreferrer' className='social-link'>
                        <img src={require('../assets/github.png')} alt='GitHub' className='social-icon' />Github
                    </a>
                    <a href='https://www.linkedin.com/in/abdur1911/' target='_blank' rel='noopener noreferrer' className='social-link'>
                        <img src={require('../assets/Linkedin.png')} alt='LinkedIn' className='social-icon' />Linkedin
                    </a>
                    <a href='https://www.instagram.com/abdur_rahman1911?igsh=Znk5eGlydmtyYnI4&utm_source=qr' target='_blank' rel='noopener noreferrer' className='social-link'>
                        <img src={require('../assets/instagram.png')} alt='Instagram' className='social-icon' />Instagram
                    </a>
                </div>
            </div>
        </div>        
        </>
    );
}

export default QuickIntro;